import * as EmailValidator from 'email-validator';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

// Validators have two forms:
// validateXxx(value) return undefined or error message
// XxxValidator(callback) returns a function for an event callback
//
// The suggested use of the validator for minimum obnoxiousness:
//  - if not in error state, only revalidate on blur.
//  - if in error state, revalidate on every change.
//
// <TextField
//   ...
//  onBlur={emailValidator(setEmailError)}
//  onChange={emailError && emailValidator(setEmailError)}
// />

export const validateEmail = email => {
  if (email === '') {
    return 'Email cannot be empty.';
  } else if (!EmailValidator.validate(email)) {
    return 'This doesn\'t look like an email address.';
  }
};

export const validateUsername = username => {
  if (username === '') {
    return 'Username cannot be empty.';
  }
  if (!username.match(/^[a-zA-Z0-9.\-@_ ]+$/)) {
    return 'Username can only contain letters, numbers, spaces and \'-\', \'_\' and \'@\'.';
  }
};

export const validatePassword = password => {
  if (password === '') {
    return 'Password cannot be empty.';
  }
  if (password.length < 8) {
    return 'Password must have at least 8 characters.';
  }
  if (!password.match(/[0-9]/) ||
      !password.match(/[A-Z]/) ||
      !password.match(/[a-z]/)) {
    return 'Password must have lower-case, upper-case and digits.';
  }
};

export const validateFirstName = firstName => {
  if (firstName === '') {
    return 'First name is required.';
  }
};

export const validateLastName = lastName => {
  if (lastName === '') {
    return 'Last name is required.';
  }
};

export const validatePhone = phone => {
  const phoneNumber = parsePhoneNumberFromString(phone, 'AU');
  if (!phoneNumber || !phoneNumber.isValid()) {
    return 'That doesn\'t look like a valid telephone number.';
  }
};

export const validateNdisNumber = value => {
  // https://www.ndis.gov.au/media/2016/download
  const isRightLength = value.match(/^\d{9}$/);
  const isRightFirstDigits = parseInt(value.substring(0, 2)) === 43;
  if (!isRightLength || !isRightFirstDigits) {
    return 'The NDIS number you provided is not valid. It should be 9 digits long, with no spaces, and start with \'43\'.';
  }
};
